"use client";

import { Icons } from "@/components/icons";
import { Button } from "@/components/ui/button";
import { useTranslations } from "next-intl";
import MaxWidthDiv from "@/components/max-width-div";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslations("error");

  return (
    <main className="bg-white grow flex items-center justify-center">
      <MaxWidthDiv className="flex flex-col gap-8 items-center justity-center space-y-6 py-10 lg:py-20 bg-white">
        <div className="flex flex-col gap-2 items-center ">
          <h1 className="text-[30px] leading-none">{t("ops")}</h1>
          <p>{t("somethingWentWrong")}</p>
          <div className="animate-spin bottom-2 left-0 right-0 w-min mx-auto">
            <Icons.dish height={90} width={90} />
          </div>
        </div>

        <Button
          onClick={() => reset()}
          variant="default"
          className="!mt-2 uppercase"
          size="lg"
        >
          {t("tryAgain")}
        </Button>
      </MaxWidthDiv>
    </main>
  );
}
